import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import api from "../../lib/api";
import { dayMonth, TEAM_LABELS } from "../../lib/format";
import SectionHeading from "../SectionHeading";
import { Reveal } from "../Reveal";
import EmptyState from "../EmptyState";

export default function HomeEvents() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, []);

  const upcoming = (events || [])
    .filter((e) => e.date >= new Date().toISOString().slice(0, 10))
    .slice(0, 3);

  return (
    <section className="bg-white py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <SectionHeading number="04" kicker="Calendrier" title={<>Prochaines courses</>} />
          <Reveal delay={0.2}>
            <Link
              to="/calendrier"
              data-testid="events-see-all"
              className="group inline-flex items-center gap-3 border border-navy/25 text-navy font-heading uppercase tracking-wider text-sm px-6 py-3.5 hover:border-rouge hover:text-rouge transition-[border-color,color] duration-300"
            >
              Voir tout le calendrier
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>

        {events !== null && upcoming.length === 0 ? (
          <EmptyState
            title="Aucune prochaine course"
            message="Aucune prochaine course n'est actuellement programmée. Le calendrier sera mis à jour dès l'ajout des prochaines échéances."
            testId="home-events-empty"
          />
        ) : (
          <div data-testid="home-events-list" className="border-t border-navy/10">
            {upcoming.map((event, i) => {
              const d = dayMonth(event.date);
              return (
                <Reveal key={event.id} delay={i * 0.08}>
                  <Link
                    to="/calendrier"
                    data-testid={`home-event-${event.id}`}
                    className="group flex items-center gap-5 sm:gap-8 border-b border-navy/10 py-6 sm:py-7"
                  >
                    <div className="shrink-0 w-[72px] bg-navy text-white text-center py-3 transition-colors duration-300 group-hover:bg-rouge">
                      <span className="block font-heading font-semibold text-2xl leading-none">{d.day}</span>
                      <span className="block text-[10px] uppercase tracking-widest mt-1 opacity-80">{d.month} {d.year}</span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="font-heading uppercase font-semibold tracking-tight text-navy text-lg sm:text-2xl truncate group-hover:text-rouge transition-colors duration-300">
                        {event.name}
                      </h3>
                      <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-steel">
                        <span className="inline-flex items-center gap-1.5"><MapPin size={13} className="text-rouge" />{event.location}</span>
                        <span className="uppercase tracking-wider text-xs font-semibold">{event.categories || event.category}</span>
                      </p>
                    </div>
                    <span className="hidden sm:inline-block shrink-0 border border-navy/15 text-navy/70 text-xs font-heading uppercase tracking-wider px-4 py-2">
                      {TEAM_LABELS[event.team] || event.team}
                    </span>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
